<template>
<v-container class="pa-0 pb-12">
	<v-row class="px-3 fill-height scroll-wrapper" ref="row" >
		<v-col
			cols="12"
			md="12" class="pa-0">
			<v-card color="#000" width="100%" class="mx-auto" rounded="0">
				<v-card-title class="tabel-header">
				<div class="title">
					<v-icon color="#ffbe00" class="back" @click="back">mdi-chevron-left</v-icon>
					<div>{{$t('text.events')}}<template v-if="selectedCompetition"> - {{selectedCompetition.name}}</template></div>
				</div>
				</v-card-title>
				<v-card-text class="pa-0 card-text">
					<div v-for="(e, i) in Entries" class="f-row data-row pl-1" :class="{ 'zebra-dark': (i%2), 'zebra-light': !(i%2)}" :key="i">
						<div class="f-row w-100 cont" :class="{'disabled': !e.registrationOpen}">
							<div class="checkbox"><c-checkbox v-model="e.start" :readonly="!e.registrationOpen" :color="getCheckboxColor(e)" :backgroundColor="(i%2) ? '#222' : '#444'" @change="onStartChange(e.id, e.start)"></c-checkbox></div>
							<!-- :readonly="!e.registrationOpen" -->
							<div class="w-20 ev-class">
								<div><b>{{ e.event_Name }}</b></div>
								<div>{{ e.event_Class }}</div>
							</div>
							<div class="f-grow f-column name">
								<div><b>{{ e.competitor_Lastname }} {{ e.competitor_Firstname }}</b></div>
								<div>{{e.club_Name}}</div>
							</div>
							<div>
								<v-icon color="#fff" size="1.0em" class="pr-1 icon">mdi-clock-outline</v-icon>
							</div>
							<div>
								<div><b>{{ e.registrationDeadline | moment('DD.MM') }}</b></div>
								<div class="time">{{ e.registrationDeadline | moment('HH:mm') }}</div>
							</div>
							<div>
								<div class="delete"><v-icon color="#fff" x-large @click="onDelete(e.id)">mdi-book-remove</v-icon></div>
							</div>
						</div>
					</div>
				</v-card-text>
			</v-card>
			<spinner :loading="loading"></spinner>
		</v-col>
	</v-row>
	<v-row><v-col cols="12" sm="4">

			<c-button
				:disabled="loading"
				@click="scan"
				:label="$t(`text.scanRegMan`)"
				class="w-100">
			</c-button>
		</v-col></v-row>
</v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

import digiRegmanActions from '../store/actions/digiRegman';
import namespace from '../store/namespace';

import Spinner from '../general/Spinner.vue';

import CButton from '../globalComponents/CButton.vue';
import CCheckbox from '../globalComponents/CCheckbox.vue';

import modelState from '../mixins/modelState';

export default {
	name: 'CompetitionDetail',
	mixins: [modelState],
	components: {
		CCheckbox,
		Spinner,
		CButton,
	},
	data() {
		return {
			loading: true,
		};
	},
	async mounted() {
		this.SET_ENTRIES(null);
		await this.loadData();
	},
	watch: {
		'WindowSize.y': function () {
			this.$refs.row.style.maxHeight = `${this.WindowSize.y - 170}px`;
		},
		Entries() {
			this.$refs.row.style.maxHeight = `${this.WindowSize.y - 170}px`;
		},
	},
	computed: {
		...mapGetters(['WindowSize']),
		...mapGetters(namespace.DIGIREGMAN, ['Links', 'Competitions', 'Entries']),
		selectedCompetition() {
			return this.Competitions.find(x => x.id === this.$route.params.cId);
		},
	},
	methods: {
		...mapActions(namespace.DIGIREGMAN, [
			digiRegmanActions.GET_DIGI_REG_LINKS,
			digiRegmanActions.GET_COMPETITIONS,
			digiRegmanActions.SET_START,
			digiRegmanActions.GET_COMPETITIONENTRIES,
			digiRegmanActions.REMOVE_COMPETITOR]),
		...mapMutations(namespace.DIGIREGMAN, [
			digiRegmanActions.SET_ENTRIES,
		]),
		async loadData() {
			this.loading = true;
			try {
				if (this.Links.length === 0) await this.GET_DIGI_REG_LINKS();
				if (this.Competitions.length === 0) await this.GET_COMPETITIONS();
				await this.GET_COMPETITIONENTRIES(this.$route.params.cId);
			} finally {
				this.loading = false;
			}
		},
		async onStartChange(id, val) {
			this.loading = true;
			try {
				await this.SET_START({ id, val });
			} finally {
				this.loading = false;
			}
		},
		async onDelete(id) {
			this.loading = true;
			try {
				// eslint-disable-next-line no-restricted-globals, no-alert
				const del = confirm(this.$t('text.removeRegMan'));
				if (del) {
					const ret = await this.REMOVE_COMPETITOR(id);
					if (ret) {
						await this.loadData();
					}
				}
			} finally {
				this.loading = false;
			}
		},
		back() {
			this.$router.push({ name: 'competitions' });
		},
		getCheckboxColor(entry) {
			if (entry.start) {
				return 'rgb(83, 167, 0)';
			}

			if (entry.registrationOpen) {
				return '#ffbe00';
			}

			return '#ad0303';
		},
		scan() {
			this.$router.push({ name: 'qr' });
		},
	},
};
</script>

<style lang="scss" scoped>

@import "../globalComponents/style/_globals";

.tabel-header {
	color: $seltec_color;
	height: 40px;
	padding:5px 10px;

	.title {
		overflow: hidden;
		max-height: 100%;
		display: flex;

		div {
			white-space: nowrap;
			overflow: auto hidden;
		}
	}

	.back {
		cursor: pointer;
		font-size: 35px;
		margin-left: -12px;
	}
}

.scroll-wrapper {
	overflow: hidden auto;
}

.checkbox {
	padding: 2px;
}
.delete {
	width:44px;
	height: 44px;
	padding: 2px;
}

.icon {
	padding-bottom: 3px;
}

.time {
	text-align: right;
}

.card-text {
	background-color: #fff;
}

.data-row {
	color: $font-light-color;
	cursor: pointer;
}

.zebra-dark {
	background-color: $zebra-dark;
}

.zebra-light {
	background-color: $zebra-light;
}

.no-data {
	color:$font-light-color;
}

@media screen and (max-width: 380px) {
	.name {
		order:1;
		width:100%;
		padding-left: 43px;
	}

	.ev-class {
		flex-grow:1;
	}

	.cont {
		flex-wrap: wrap;
	}
}
</style>
